// Device shadows carry the deploy environment as a full name ("Staging",
// "Development", "Production") that is too wide for the tables and panels that
// show it, so it is rendered by its first letter.
export const environmentMapper = (env) => {
  if (env?.[0] === "S") {
    return "Stage";
  }
  if (env?.[0] === "D") {
    return "Dev";
  }
  if (env?.[0] === "P") {
    return "Prod";
  }
  return "";
};

// must match DEVICE_ENVIRONMENTS in agamotto-organization-lambda-ms/utils/fleet.ts
export const ENV_OPTIONS = ["DEVELOPMENT", "STAGING", "PRODUCTION"];

// clamps REACT_APP_ENV to one of the allowed values, "" (unfiltered) otherwise -
// an unrecognised value must never reach a route that 400s on it
export const clampAppEnv = () => {
  const env = process.env.REACT_APP_ENV?.toUpperCase();
  return ENV_OPTIONS.includes(env) ? env : "";
};
